import React, { useState } from 'react';

export default function LoginPage({ onLogin, googleLoginUrl = '', initialError = '' }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(initialError);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setIsSubmitting(true);

    try {
      await onLogin({ email: email.trim(), password });
    } catch (error) {
      setErrorMessage(error?.message || 'Unable to sign in.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#070b14] px-5 py-10 text-gray-100">
      <div className="w-full max-w-md rounded-2xl border border-gray-800 bg-[#0b1020] p-7 shadow-2xl sm:p-9">
        <div className="mb-8">
          <div className="mb-5 inline-flex rounded-md border border-cyan-300/20 bg-cyan-300/10 px-3 py-2 text-xs font-black uppercase tracking-[0.18em] text-cyan-100">
            samsar
          </div>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-cyan-200/70">
            Global administration
          </p>
          <h1 className="mt-2 text-3xl font-semibold text-white">Sign in</h1>
          <p className="mt-2 text-sm leading-6 text-gray-400">
            Use an account with administrator privileges to continue.
          </p>
        </div>

        <form className="space-y-5" onSubmit={handleSubmit}>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-300" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="min-h-12 w-full rounded-lg border border-gray-700 bg-gray-950 px-3.5 text-gray-100 outline-none placeholder:text-gray-600 focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400"
              placeholder="admin@example.com"
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-medium text-gray-300" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="min-h-12 w-full rounded-lg border border-gray-700 bg-gray-950 px-3.5 text-gray-100 outline-none placeholder:text-gray-600 focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400"
              placeholder="Enter your password"
            />
          </div>

          {errorMessage && (
            <div role="alert" className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-200">
              {errorMessage}
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="min-h-12 w-full rounded-lg bg-cyan-300 px-4 font-semibold text-gray-950 transition hover:bg-cyan-200 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {isSubmitting ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        {googleLoginUrl && (
          <>
            <div className="my-6 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.18em] text-gray-600">
              <span className="h-px flex-1 bg-gray-800" />
              or
              <span className="h-px flex-1 bg-gray-800" />
            </div>

            <a
              href={googleLoginUrl}
              className="flex min-h-12 w-full items-center justify-center gap-3 rounded-lg border border-gray-700 bg-gray-950 px-4 font-semibold text-gray-100 transition hover:border-gray-500 hover:bg-gray-900"
            >
              <span
                aria-hidden="true"
                className="flex h-6 w-6 items-center justify-center rounded-full bg-white text-sm font-black text-blue-600"
              >
                G
              </span>
              Continue with Google
            </a>
          </>
        )}
      </div>
    </main>
  );
}
